// 조용한 온천 장면이 함께 쓰는 재질. 프로토타입 288–294.
import { plush } from '../../engine/materials';

export const stoneMat = (c: string) => plush(c, '#DDE2DA', 0.03);
/** 눈: 카메라 앞에서는 디더로 사라진다 (fade). */
export const snowMat = plush('#F4F7FA', '#FFFFFF', 0.04, true);
export const iceMat = plush('#E2F0F5', '#FFFFFF', 0.1);
export const rockMats = ['#6F746F', '#7E827C', '#666B67', '#8A8D86'].map(stoneMat);
export const cedar = plush('#C98E58', '#F0C795', 0.05), cedarDark = plush('#8E6440', '#BC946C', 0.04);
export const oldWood = plush('#5C4838', '#86705C', 0.03, true), logWood = plush('#6E5644', '#9A826C', 0.04, true), deckWood = plush('#7A6450', '#A58C74', 0.03);
